import { getPromotionRemainingQuantity } from "@fripick/cart-utils";

export function getPromotionName(promotion) {
  if (!promotion) return "";
  const promoNames = {
    FEATURED_DATE: "Fecha Destacada",
    PRODUCT: "Por Producto",
    BIRTHDAY: "Cumpleaños",
    LOYALTY: "Lealtad",
    RECONQUEST: "Reconquista",
    FIRST_BUY: "Primera Compra",
  };
  return promoNames[promotion.promoName] || promotion.promoName;
}

export function getPromotionToApply(itemId, promotions) {
  return (
    promotions
      .filter((promotion) => promotion.itemId === itemId)
      .filter((promotion) => getPromotionRemainingQuantity(promotion) > 0)
      .sort((a, b) => b.promoId - a.promoId)[0] ?? null
  );
}
